/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */


export const FilterParams = [
  'near' , 'price' , 'day' , 'time' , 'subject' , 'extendedClassType' , 'extendedCourseType' , 'km' , 'after' , 'before' , 'debugQuery' , 'tag' , 'site' , 'tutorId' , 'duration' , 'faculty' , 'combineMode'
];

export type FilterParams = keyof typeof FilterParams;